const trackEvent = (event, data) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, data);
  }
};

export const trackSearchSubmitted = (searchTerm, searchLength) => {
  trackEvent('search_query_submitted', {
    search_term: searchTerm,
    search_length: searchLength,
  });
};

export const trackSearchResultsView = (searchTerm, resultCount, resultTimeMs) => {
  trackEvent('search_results_viewed', {
    search_term: searchTerm,
    result_count: resultCount,
    results_time_ms: resultTimeMs,
  });
};

export const trackSearchClick = (searchTerm, resultPosition, resultUrl) => {
  trackEvent('search_result_clicked', {
    search_term: searchTerm,
    result_position: resultPosition,
    result_url: resultUrl,
  });
};

export const trackNoResults = (searchTerm, searchLength, activeFilters = null) => {
  const eventData = {
    search_term: searchTerm,
    search_length: searchLength,
  };

  if (activeFilters && activeFilters.length > 0) {
    eventData.active_filters = activeFilters;
  }

  trackEvent('no_results_returned', eventData);
};

export const trackFilterApplied = (filterType, filterValue) => {
  trackEvent('search_filter_applied', {
    filter_type: filterType,
    filter_value: filterValue,
  });
};
